/**
 * Thin navigation seam. The legacy create-account flow does a hard
 * `window.location.replace` to the new project; isolating it here keeps the
 * hook unit-testable (jsdom locks `window.location`, so tests mock this module).
 */
export const replaceLocation = (url: string): void => {
  window.location.replace(url);
};
